
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home-battery/financing",
      function () {
        return require("private-next-pages/home-battery/financing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/home-battery/financing"])
      });
    }
  